export enum nameFormats {
    firstname_lastname = 1,
    firstname_lastname_uppercase = 2,
    firstname_lastname_lowercase = 3,
    firstname_lastname_firstname_uppercase = 4,
    firstname_lastname_lastname_uppercase = 5,

    lastname_firstname = 6,
    lastname_firstname_uppercase = 7,
    lastname_firstname_lowercase = 8,
    lastname_firstname_firstname_uppercase = 9,
    lastname_firstname_lastname_uppercase = 10,

    firstnameInitial_lastname = 11,
    firstnameInitial_lastname_uppercase = 12,
    firstnameInitial_lastname_lowercase = 13,
    firstnameInitial_lastname_firstname_uppercase = 14,
    firstnameInitial_lastname_lastname_uppercase = 15,

    firstname_lastnameInitial = 16,
    firstname_lastnameInitial_uppercase = 17,
    firstname_lastnameInitial_lowercase = 18,
    firstname_lastnameInitial_firstname_uppercase = 19,
    firstname_lastnameInitial_lastname_uppercase = 20,

    lastnameInitial_firstname = 21,
    lastnameInitial_firstname_uppercase = 22,
    lastnameInitial_firstname_lowercase = 23,
    lastnameInitial_firstname_firstname_uppercase = 24,
    lastnameInitial_firstname_lastname_uppercase = 25,

    firstnameInitial_lastnameInitial = 26,
    firstnameInitial_lastnameInitial_uppercase = 27,
    firstnameInitial_lastnameInitial_lowercase = 28,
    firstnameInitial_lastnameInitial_firstname_lowercase = 29,
    firstnameInitial_lastnameInitial_lastname_lowercase = 30,

    firstname = 31,
    firstname_uppercase = 32,
    firstname_lowercase = 33,

    lastname = 34,
    lastname_uppercase = 35,
    lastname_lowercase = 36,
}
